












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: `ArrowIcon`,
})
export default class ArrowIcon extends Vue {
  @Prop({ default: `currentColor`, type: String, validator: prop => /^#([0-9A-F]{3}){1,2}$/i.test(prop) || prop === `currentColor` })
  protected color!: string;

  @Prop({ default: ``, type: String })
  protected title!: string;
}
